import React, { useState, useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { useAuth } from '../../../contexts/AuthContext'
import { useOnboardingIntent } from './useOnboardingIntent'
import { IntentPickerModal } from './IntentPickerModal'
import { isKitBuyer, clearKitBuyer } from '../../../utils/kitBuyer'

export const IntentPickerController: React.FC = () => {
  const { onboardingPickerRequestId, userAccount } = useAuth()
  const { shouldShow, recordKitBuyerIntent } = useOnboardingIntent()
  const { pathname, search } = useLocation()
  const [isOpen, setIsOpen] = useState(false)
  // True when the picker opened by itself (first run) rather than from "Show me around".
  const [autoOpened, setAutoOpened] = useState(false)
  const prevRequestId = useRef(onboardingPickerRequestId)
  const kitBuyerWriteStarted = useRef(false)

  // Kit buyers are here to register their kit, not to be pitched a kit again.
  const onKitRoute =
    pathname.startsWith('/dna-kit') ||
    (pathname.startsWith('/account') && new URLSearchParams(search).get('tab') === 'dna-kits')

  useEffect(() => {
    const explicitRequest = onboardingPickerRequestId > prevRequestId.current
    prevRequestId.current = onboardingPickerRequestId

    if (explicitRequest) {
      setAutoOpened(false)
      setIsOpen(true)
      return
    }
    if (!shouldShow) return

    if (isKitBuyer()) {
      if (!kitBuyerWriteStarted.current) {
        kitBuyerWriteStarted.current = true
        recordKitBuyerIntent().then(
          () => clearKitBuyer(),
          (err) => console.warn('Failed to record kit buyer intent', err)
        )
      }
      return
    }
    if (onKitRoute) return

    setAutoOpened(true)
    setIsOpen(true)
  }, [shouldShow, onboardingPickerRequestId, onKitRoute, recordKitBuyerIntent])

  return (
    <IntentPickerModal
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      askHeardAbout={autoOpened && !userAccount?.heardAbout}
    />
  )
}
